import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { t } from "@lingui/macro";
import { I18n } from "@lingui/react";

import ResetPassword from "../../components/Auth/AuthForm/ResetPassword";

const ResetScene = () => (
  <div>
    <I18n>
      {({ i18n }) => (
        <div className="Wrapper-inner">
          <Helmet
            title={i18n._(t("reset_password.form_title")`Reset Password`)}
          />
          <ResetPassword />
        </div>
      )}
    </I18n>
  </div>
);

ResetScene.propTypes = {};
ResetScene.defaultProps = {};

export default ResetScene;
